const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validateEmail = (email?: string): { isValid: boolean; error?: string } => {
  if (email == null || email.trim() === "") {
    return { isValid: false, error: "Email is required" };
  }

  if (!emailRegex.test(email.trim())) {
    return { isValid: false, error: "Please enter a valid email address" };
  }

  return { isValid: true };
};
